import { useState, useEffect, useCallback } from "react";
import { SPECIALIST_HOSTNAME } from "env-vars";
import { useAdminContent } from "context/admin-content";
import { Patient } from "./types";

export function usePatient() {
  const adminContent = useAdminContent();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [patient, setPatient] = useState<Patient | null>(null);

  const getPatient = useCallback(async () => {
    setIsLoading(true);

    const patientId = localStorage.getItem("ciq_id");
    const idToken = localStorage.getItem("id_token");
    const response = await fetch(
      `${SPECIALIST_HOSTNAME}/api/v1/people/${patientId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    if (response.ok) {
      const { person } = await response.json();

      setIsLoading(false);

      return person;
    }

    setIsLoading(false);
  }, []);

  const refetch = useCallback(() => {
    setPatient(null);
  }, []);

  useEffect(() => {
    if (adminContent?.isLoading || patient) {
      return;
    }

    (async () => {
      const person = await getPatient();

      if (person) {
        setPatient(person);
      }
    })();
  }, [adminContent?.isLoading, patient, getPatient]);

  return { patient, refetch, isLoading };
}
